import { FeatureData } from "views/components/Schedules/components/UpdateActivityPopup/styles";

const PCContent = ({
    id, 
    name,
    brand,
    barcode
}) => {
    return (
        <FeatureData>
            <p>
                <b>{name} ({id})</b>
                <br/>
                {brand}
                <br/>
                Código de barras: {barcode}
            </p>
        </FeatureData>
    );
}

export default PCContent;